module.exports = __webpack_public_path__ + "img/side-arch-normal.64634018.svg";